<template>
  <div>
    <h1 class="mt-4 mb-4 primary--text">Patient timeline</h1>
    <v-timeline dense>
      <v-timeline-item
        class="mb-3"
        color="success"
        small
        icon="check"
      >
        Patient signed up on {{timeline.signup.at | moment('MM/D/Y - LT')}}
      </v-timeline-item>

      <v-timeline-item
        v-if="timeline.signup.status === 'ACTIVE'"
        class="mb-3"
        color="success"
        small
        icon="check"
      >
        Patient confirmed signup
      </v-timeline-item>

      <v-timeline-item
        v-if="timeline.signup.status === 'AWAITING_CONSENT'"
        class="mb-3"
        color="info"
        small
      >
        <v-alert value="1" type="info" outline>Awaiting patient consent</v-alert>
      </v-timeline-item>

      <v-timeline-item
        color="info"
        icon="list"
        class="mb-3"
      >
        <v-card dark class="info">
          <v-card-title class="title">Course 1 - Understanding diabetes</v-card-title>
          <v-card-text class="white text--primary">
            <div v-for="mission in getStackMissions('EnDiabnextUnderstandingDiabetesStack')">
              <span v-if="mission.done"><v-icon class="success--text mr-2">check_circle_outline</v-icon></span>
              <span :style="!mission.done && 'margin-left: 32px'">{{mission.module.label}}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>

      <v-timeline-item
        color="info"
        icon="list"
        class="mb-3"
      >
        <v-card dark class="info">
          <v-card-title class="title">Course 2 - Hba1c followup</v-card-title>
          <v-card-text class="white text--primary">
            <div v-for="mission in getStackMissions('EnDiabnextHba1cFollowUpStack')">
              <span v-if="mission.done"><v-icon class="success--text mr-2">check_circle_outline</v-icon></span>
              <span :style="!mission.done && 'margin-left: 32px'">{{mission.module.label}}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>

      <v-timeline-item
        color="info"
        icon="list"
        class="mb-3"
      >
        <v-card dark class="info">
          <v-card-title class="title">Course 3 - Adjusting insulin doses</v-card-title>
          <v-card-text class="white text--primary">
            <div v-for="mission in getStackMissions('EnDiabnextIAdjustMyInsulinDosesStack')">
              <span v-if="mission.done"><v-icon class="success--text mr-2">check_circle_outline</v-icon></span>
              <span :style="!mission.done && 'margin-left: 32px'">{{mission.module.label}}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>

      <v-timeline-item
        color="info"
        icon="list"
        class="mb-3"
      >
        <v-card dark class="info">
          <v-card-title class="title">Course 4 - Glycemic index</v-card-title>
          <v-card-text class="white text--primary">
            <div v-for="mission in getStackMissions('EnDiabnextGlycemicIndexStack')">
              <span v-if="mission.done"><v-icon class="success--text mr-2">check_circle_outline</v-icon></span>
              <span :style="!mission.done && 'margin-left: 32px'">{{mission.module.label}}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
    import api from 'api'

    export default {
        data() {
            return {
                checkedThisMonth: false,
                checks: []
            }
        },

        methods: {
            getStackMissions(stackName) {
                return this.timeline.missions.filter(m => {
                    if (m.stack) {
                        return m.stack.name === stackName
                    }
                    return false
                })
            },

            getPatientChecks() {
                api.get(`diabnext/patients/${this.$route.params.patient_id}/check`)
                    .then(res => {
                        this.checkedThisMonth = res.data.checkedThisMonth
                        this.checks = res.data.checks
                    })
            },

            setChecked() {
                api.post(`diabnext/patients/${this.$route.params.patient_id}/check`)
                    .then(res => {
                        this.getPatientChecks()
                        this.$mango.snackbar({text: 'Profil patient vérifié pour ce mois.', color: 'success'})
                    })
            }
        },

        mounted() {
            this.getPatientChecks()
        },

        props: {
            timeline: {
                type: Object,
                required: true
            }
        }
    }
</script>
